import { Link } from "react-router-dom";
import authStyles from "../pages/auth/auth.module.css"
import { Carousel } from "antd";


const AuthCarousel = () => {
  const carouselItems = [
    {
      id: 1,
      background: "/assets/img/carosuel/untoxh.png",
    },
    // {
    //   id: 2,
    //   background: "/assets/img/carosuel/02_BloodStrong.jpg",
    // },
    // {
    //   id: 3,
    //   background: "/assets/img/carosuel/03_FoodMonsters.jpg",
    // },
    // {
    //   id: 4,
    //   background: "/assets/img/carosuel/04_HappySacks.jpg",
    // },
    // {
    //   id: 5,
    //   background: "/assets/img/carosuel/05_FoodAlert.jpg",
    // },
    // {
    //   id: 6,
    //   background: "/assets/img/carosuel/06_BrokenHearts.jpg",
    // },
    // {
    //   id: 7,
    //   background: "/assets/img/carosuel/07_GiveAShit.jpg",
    // },
    // {
    //   id: 8,
    //   background: "/assets/img/carosuel/08_Collection.jpg",
    // },
  ];
  return (
    <div
    //  to="/"
      // href={
      //   process.env.NEXT_PUBLIC_PLATFORM === "staging"
      //     ? process.env.NEXT_PUBLIC_ECOM_BASE_URL_STAGE
      //     : process.env.NEXT_PUBLIC_WEBSITE
      // }
      className={`col-lg-6 col-md-12 ${authStyles.imgColumn}`}
    >
      {/* <Link className="navbar-brand auth-img " href="/">
              <Image
                src="/assets/img/know.png"
                width={100}
                height={100}
                alt="know.ecommerce"
              />
            </Link>
            <span className="fs-6 text-light text-center">
              Let&apos;s you care for yourself and
              <br />
              the people you love
            </span> */}
      <Carousel dots autoplay fade dotPosition="top">
        {carouselItems.map((item) => (
          <div
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
            }}
            // className="rounded rounded-1"
            className={`${authStyles.imggColumn}`}
            key={item?.id}
          >
            <img
              src={item?.background}
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default AuthCarousel;
